import React from 'react';
import { ModalComponent } from 'baseComponents/ModalComponent';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { TextComponent } from 'baseComponents/TextComponent';

interface Props {
  isModalOpen: boolean;
  closeModal: () => void;
  handleRemoveAudience: () => void;
}

export const RemoveAudienceModal: React.FC<Props> = (props) => {
  return (
    <ModalComponent
      title='Remove audience'
      close={props.closeModal}
      open={props.isModalOpen}
    >
      <TextComponent text='Are you sure you want to remove the audience?' />
      <div className='remove-campaign-btns'>
        <ButtonComponent
          appereance='warning'
          size='middle'
          onClick={props.handleRemoveAudience}
          label='Remove audience'
          fullWidth
        />
        <ButtonComponent
          appereance='secondary'
          size='middle'
          onClick={props.closeModal}
          label='Cancel'
          fullWidth
        />
      </div>
    </ModalComponent>
  );
};
